export default defineNuxtRouteMiddleware((to) => {
	const { loggedIn, user } = useUserSession();
	if (
		to.path === '/login' ||
		to.path === '/signup' ||
		to.path === '/forgot-password' ||
		to.path.startsWith('/reset-password/')
	) {
		if (loggedIn.value) {
			return navigateTo('/');
		}
		return;
	}

	if (to.path.startsWith('/auth/verify')) {
		return;
	}

	if (to.path.startsWith('/signup/')) {
		if (loggedIn.value) {
			return navigateTo(`/join/${to.path.slice(8)}`);
		}
		return;
	}

	if (
		to.path === '/tos' ||
		to.path === '/privacy' ||
		to.path === '/pricing' ||
		to.path === '/refund' ||
		to.path === '/contact' ||
		to.path.startsWith('/docs')
	) {
		return;
	}

	if (!loggedIn.value && to.path !== '/') {
		return navigateTo('/login');
	}

	if ((to.path.startsWith('/profile/admin') || to.path.startsWith('/email')) && user.value?.role !== 'admin') {
		return navigateTo('/profile');
	}
});
